var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticStyle: { width: "95%" }, attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-wrap" },
        [
          _c("h1", [
            _vm._v(
              "(" +
                _vm._s(_vm.hotelcode) +
                ") " +
                _vm._s(_vm.hotelname) +
                " Batch Loader"
            ),
          ]),
          _vm._v(" "),
          _c("ies-hotel-quick-links", { attrs: { pageid: _vm.hotelkey } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "Rates are in " +
            _vm._s(_vm.currencycode) +
            " per room/unit per night" +
            _vm._s(_vm.taxSummary)
        ),
      ]),
      _vm._v(" "),
      _vm.responseData
        ? _c("ies-hotel-planner-month-controls", {
            staticClass: "d-none d-lg-block",
            attrs: {
              hotelkey: _vm.hotelkey,
              rateColumns: _vm.rateColumns,
              selectedDate: _vm.dateFrom,
              isPlannerPage: false,
              resetMonthControls: _vm.resetMonthControls,
            },
            on: {
              "update:selectedDate": function ($event) {
                _vm.dateFrom = $event
              },
              "update:selected-date": function ($event) {
                _vm.dateFrom = $event
              },
              "update:resetMonthControls": _vm.handleMonthControlsReset,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form-horizontal",
          attrs: { id: "batchForm", role: "form", method: "POST", action: "" },
        },
        [
          _c("div", { staticClass: "d-flex flex-wrap" }, [
            _vm.dateRanges.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "form-section mr-2 mb-2",
                    staticStyle: { "min-width": "100%" },
                  },
                  [
                    _c("h3", { staticClass: "red-dark white--text pl-2" }, [
                      _vm._v("1.) Select Dates"),
                    ]),
                    _vm._v(" "),
                    _c("ies-hotel-batch-loader-date-selector", {
                      attrs: {
                        dateRanges: _vm.dateRanges,
                        selectedDays: _vm.selectedDays,
                      },
                      on: {
                        "update-date-ranges": _vm.updateDateRanges,
                        "update-selected-days": _vm.updateSelectedDays,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-section mr-2 mb-2" },
              [
                _c("h3", { staticClass: "red-dark white--text pl-2" }, [
                  _vm._v("2.) Select Fields to load / update"),
                ]),
                _vm._v(" "),
                _vm.responseData
                  ? _c("ies-hotel-batch-loader-field-selector", {
                      attrs: { payload: _vm.fieldSelectorPayload },
                      on: {
                        "toggle-show-availability": _vm.toggleShowAvailability,
                        "toggle-closed": _vm.toggleClosed,
                        "toggle-all-hotel-rooms": _vm.toggleAllHotelRooms,
                        "toggle-hotel-room": _vm.toggleHotelRoom,
                        "toggle-rate-type": _vm.toggleRateType,
                        "toggle-additional-rate": _vm.toggleAdditionalRate,
                        "toggle-restriction": _vm.toggleRestriction,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.responseData && !_vm.responseData.isChannelManaged
              ? _c(
                  "div",
                  { staticClass: "form-section mr-2 mb-2" },
                  [
                    _c("h3", { staticClass: "red-dark white--text pl-2" }, [
                      _vm._v("3.) Enter values"),
                    ]),
                    _vm._v(" "),
                    _c("ies-hotel-batch-loader-submit-form", {
                      attrs: { payload: _vm.submitFormPayload },
                      on: {
                        "update-error-message": _vm.updateErrorMessage,
                        "save-success": _vm.handleSaveSuccess,
                      },
                    }),
                    _vm._v(" "),
                    _c("ies-hotel-batch-loader-value-selector", {
                      attrs: { payload: _vm.valueSelectorPayload },
                      on: {
                        "update-availability": _vm.updateAvailability,
                        "update-standard-rate": _vm.updateStandardRate,
                        "update-additional-rate": _vm.updateAdditionalRate,
                        "update-restriction": _vm.updateRestriction,
                        "update-universal-rate": _vm.updateUniversalRate,
                        "values-reset": _vm.handleValuesReset,
                      },
                    }),
                    _vm._v(" "),
                    _c("ies-hotel-batch-loader-submit-form", {
                      attrs: { payload: _vm.submitFormPayload },
                      on: {
                        "update-error-message": _vm.updateErrorMessage,
                        "save-success": _vm.handleSaveSuccess,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }